/**
 * categoryUtils.js — Utilitários de Resolução & Detecção de Categorias iSet
 */

const SKU_PREFIX_CATEGORY_MAP = {
  "BIO": "Biologia",
  "DIR": "Direito",
  "ENF": "Enfermagem",
  "FIS": "Fisioterapia",
  "MED": "Medicina",
  "ODON": "Odontologia",
  "VET": "Medicina Veterinária",
  "PSIC": "Psicologia",
  "PED": "Pedagogia",
  "CONT": "Contabilidade",
  "ARQ": "Arquitetura",
  "AGRO": "Agronomia",
  "EDF": "Educação Física",
  "NUT": "Nutrição",
  "FARM": "Farmácia",
  "ADM": "Administração",
  "ENG": "Engenharia",
  "GEL": "Geologia",
  "GEO": "Geografia",
  "HIST": "História",
  "LET": "Letras",
  "MATH": "Matemática",
  "MUS": "Música",
  "PEDAG": "Pedagogia",
  "QUIM": "Química",
  "SOC": "Sociologia",
  "TEO": "Teologia",
  "VETER": "Veterinária"
};

/**
 * Detecta a categoria ideal de um produto iSet baseando-se em:
 * 1. Categoria salva em produto_dados
 * 2. ID da categoria iSet (categories_id / category_id)
 * 3. Tags JSON do iSet (full_data.tags -> Categoria)
 * 4. Palavras-chave do curso contidas no nome do produto
 * 5. Mapeamento por Prefixo de SKU (ex: BIO -> Biologia, DIR -> Direito)
 */
export function detectCategoryFromProduct(item, skuPai, categoriesList = [], existingCategoriaId = null) {
  if (!categoriesList || categoriesList.length === 0) return null;

  // 1. Se já existe categoria salva em produto_dados e é válida
  if (existingCategoriaId) {
    const existingMatch = categoriesList.find(c => 
      c.id === existingCategoriaId || String(c.categories_id) === String(existingCategoriaId)
    );
    if (existingMatch) return existingMatch;
  }

  // 2. Procura por ID direto do iSet (categories_id / category_id)
  const isetCatId = item?.categories_id || item?.full_data?.categories_id || item?.full_data?.category_id;
  if (isetCatId) {
    const matchByIset = categoriesList.find(c => String(c.categories_id) === String(isetCatId));
    if (matchByIset) return matchByIset;
  }

  // 3. Tenta extrair tags do full_data (iSet)
  let tagCategoryName = null;
  if (item?.full_data?.tags) {
    try {
      const parsedTags = typeof item.full_data.tags === 'string' ? JSON.parse(item.full_data.tags) : item.full_data.tags;
      if (Array.isArray(parsedTags)) {
        const catTag = parsedTags.find(t => t.group === "Categoria" || t.group === "categoria");
        if (catTag && catTag.value) tagCategoryName = catTag.value;
      }
    } catch (_) {}
  }

  // 4. Procura por nome exato em item.category, item.full_data.category ou tagCategoryName
  const rawCatName = item?.category || item?.full_data?.category || tagCategoryName;
  if (rawCatName) {
    const matchByName = categoriesList.find(c => 
      c.nome.toLowerCase() === rawCatName.toLowerCase() || 
      rawCatName.toLowerCase().includes(c.nome.toLowerCase())
    );
    if (matchByName) return matchByName;
  }

  // 5. Procura por palavra-chave do curso no NOME do produto (ex: "Biologia" em "Anel de Formatura em Prata 925 - Biologia - Orvália")
  const productName = item?.name || item?.full_data?.name || "";
  if (productName) {
    const matchesInName = categoriesList.filter(c => 
      c.nome.length >= 4 && productName.toLowerCase().includes(c.nome.toLowerCase())
    );
    if (matchesInName.length > 0) {
      matchesInName.sort((a, b) => b.nome.length - a.nome.length);
      return matchesInName[0];
    }
  }

  // 6. Procura por Prefixo do SKU Pai (ex: BIO -> Biologia, DIR -> Direito, etc.)
  if (skuPai) {
    const prefix = skuPai.split('-')[0]?.toUpperCase();
    const targetCatName = SKU_PREFIX_CATEGORY_MAP[prefix];
    if (targetCatName) {
      const matchByPrefix = categoriesList.find(c => 
        c.nome.toLowerCase() === targetCatName.toLowerCase() || 
        c.nome.toLowerCase().includes(targetCatName.toLowerCase())
      );
      if (matchByPrefix) return matchByPrefix;
    }
  }

  return null;
}
